import { useEffect, useState } from "react";
import { API_URL,API_KEY, ENDPOINTS } from "../../constants/api";
import { apiKey } from "../../utils/ktcUtils";

 
const PendingOrders = () => {
  const [orders, setOrders] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
const [searchTerm, setSearchTerm] = useState("");

const filteredOrders = orders?.filter((order) => {
  const term = searchTerm.toLowerCase();

  return (
    order.customer?.toLowerCase().includes(term) ||
    order.tell?.toLowerCase().includes(term) ||
    order.order_id?.toString().includes(term) ||
    order.delivery_address?.toLowerCase().includes(term)
  );
});
  const user_id = 1; // replace with auth user

  // Common headers
  const headers = {
    "Content-Type": "application/json",
    'x-api-key': apiKey,
  };

  // Fetch pending orders
  const fetchOrders = async () => {
    const url =`${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/pos-pending-orders`
    console.log('url:',url)
    try {
      const res = await fetch(url, {
        headers,
      });
      const data = await res.json();
      console.log('data:',data)
      setOrders(data.report);
    } catch (err) {
      console.error("Error fetching orders:", err);
    }
  };

  // Fetch drivers
  const fetchDrivers = async () => {
    try {
      const res = await fetch(`${API_URL}/${ENDPOINTS.SYS}/get-dropdown-apikey/4154`, {
        headers,
      });
      const data = await res.json();
      setDrivers(data);
    } catch (err) {
      console.error("Error fetching drivers:", err);
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchDrivers();
  }, []);

  const openModal = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
  };

  const handleAssign = async () => {
    if (!selectedDriver) {
      alert("Please select a driver");
      return;
    }

    setLoading(true);

    try {
     const res =  await fetch(`${API_URL}/${ENDPOINTS.SYS}/create-apikey/assign-delivery`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          order_id: selectedOrder.order_id,
          delivery_id: selectedDriver,
          user_id: user_id,
        }),
      });
      const data = await res.json();

      console.log('data:',data)

      setShowModal(false);
      setSelectedDriver("");
      fetchOrders();
    } catch (err) {
      console.error("Assign error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  fetchOrders();
 
  const interval = setInterval(() => {
    fetchOrders();
  }, 60000); // 60 seconds

  return () => clearInterval(interval); // cleanup
}, []);
const totalPending = filteredOrders?.length || 0;

const totalLate =
  filteredOrders?.filter((o) => o.diff_minutes > 15).length || 0;

const totalNormal =
  filteredOrders?.filter((o) => o.diff_minutes <= 15).length || 0;
  return (
    <div className="container mt-3">
      <h4>Pending Orders</h4>
<div className="row mb-3">
  <div className="col-md-4">
    <div className="card text-center shadow-sm border-primary">
      <div className="card-body">
        <h6>Total Pending</h6>
        <h4 className="text-primary">{totalPending}</h4>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="card text-center shadow-sm border-danger">
      <div className="card-body">
        <h6>Late Orders</h6>
        <h4 className="text-danger">{totalLate}</h4>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="card text-center shadow-sm border-success">
      <div className="card-body">
        <h6>Normal Orders</h6>
        <h4 className="text-success">{totalNormal}</h4>
      </div>
    </div>
  </div>
</div>
      
<div className="mb-3">
  <input
    type="text"
    className="form-control"
    placeholder="Search by name, phone, order ID, or address..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>
{filteredOrders?.length === 0 && (
  <p className="text-muted">No orders found.</p>
)}
      {/* Orders */}
      <div className="row">
        {filteredOrders?.map((order) => (
 
   <div
  key={order.order_id}
  className="col-12 col-md-6 col-lg-4 mb-4"
>
  <div
    className={`card h-100 shadow-sm border ${
      order.diff_minutes > 15 ? 'border-danger' : 'border-secondary'
    }`}
    style={{
      backgroundColor: order.diff_minutes > 15 ? '#fff5f5' : '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}
  >
    <div className="card-body d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="card-title mb-0">Invoice #{order.order_id}</h5>
        {order.diff_minutes > 15 && (
          <span className="badge bg-danger">Overdue</span>
        )}
      </div>

      <p className="mb-1"><strong>Name:</strong> {order.customer} - {order.tell}</p>
       <p className="mb-1"><strong>Address:</strong> {order.delivery_address}</p>
      <p className="mb-1"><strong>Date:</strong> {order.date} -   <strong>
  <span className={order.diff_minutes > 15 ? 'text-danger' : 'text-success'}>
    {order.diff_minutes} Min
  </span>
</strong></p>
 
      <button
        className="btn btn-primary mt-auto"
        onClick={() => openModal(order)}
      >
        Assign Driver
      </button>
    </div>
  </div>
</div>
 ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" style={{ background: "#00000088" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              
              <div className="modal-header">
                <h5 className="modal-title">
                  Assign Driver ({selectedOrder?.id})
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>

              <div className="modal-body">
                <select
                  className="form-select"
                  value={selectedDriver}
                  onChange={(e) => setSelectedDriver(e.target.value)}
                >
                  <option value="">Select Driver</option>
                  {drivers?.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={handleAssign}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Save"}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingOrders;